import moment from 'moment-timezone';
import { DEFAULT_DATE_FORMAT } from '../common/constants';
export var timestampToDate = function (timestamp, timezone) {
    if (!timestamp) {
        return null;
    }
    else if (!timezone) {
        return new Date(timestamp);
    }
    else {
        // DatePicker operates in Browser's local timezone, so we must do conversion for User-selected timezone
        var dateInUserTimezone = moment.tz(timestamp, timezone);
        var dateAsString = dateInUserTimezone.format(DEFAULT_DATE_FORMAT);
        return new Date(dateAsString);
    }
};
export var dateToTimestamp = function (date, timezone) {
    if (!date) {
        return undefined;
    }
    if (!timezone) {
        return date.getTime();
    }
    else {
        // DatePicker operates in Browser's local timezone, so we must do conversion for User-selected timezone
        var selectedDateAsString = moment(date).format(DEFAULT_DATE_FORMAT);
        var dateInUserTimezone = moment.tz(selectedDateAsString, timezone);
        return dateInUserTimezone.valueOf();
    }
};
//# sourceMappingURL=utils.js.map